import { createApi } from '@reduxjs/toolkit/query/react';

import { WidgetConfigDto } from '../common/dto/dashboard.dto';
import { WidgetDataNumberDto, WidgetDataTimeSeriesDto } from '../common/dto/widget-data.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_CHART_SERVICE;
const TAG_TYPE = 'Widget';

export const widgetDataApi = createApi({
  reducerPath: 'widgetDataApi',
  baseQuery: customFetchBase(`${API_URI}/api/widget-data`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    getNumberOrSummaryData: builder.mutation<WidgetDataNumberDto[], WidgetConfigDto>({
      query: (body) => {
        const { layout, ...rest } = body;
        return { url: `/number-or-summary/`, method: 'PATCH', body: rest };
      },
    }),
    getTimeseriesData: builder.mutation<WidgetDataTimeSeriesDto[], WidgetConfigDto>({
      query: (body) => {
        const { layout, ...rest } = body;
        return {
          url: `/timeseries/`,
          method: 'PATCH',
          body: rest,
        };
      },
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useGetNumberOrSummaryDataMutation, useGetTimeseriesDataMutation } = widgetDataApi;
